/**
 * 认证服务
 */

import { apiClient } from './apiClient';

export class AuthService {
  /**
   * Telegram WebApp 用户注册/登录
   */
  async telegramRegister(initData: string): Promise<any> {
    const response = await apiClient.post<any>('/telegram/register', {
      initData,
    });

    if (!response.success) {
      throw new Error(response.message || 'Telegram 用户注册/登录失败');
    }

    return response.data;
  }

  /**
   * 验证 JWT Token
   */
  async verifyToken(): Promise<any> {
    const response = await apiClient.get<any>('/auth/verify');

    if (!response.success) {
      throw new Error(response.message || 'Token 验证失败');
    }

    return response.data;
  }

  /**
   * 获取认证配置状态
   */
  async getAuthConfig(): Promise<any> {
    const response = await apiClient.get<any>('/auth/config');

    if (!response.success) {
      throw new Error(response.message || '获取认证配置状态失败');
    }

    return response.data;
  }
}

export const authService = new AuthService();
